import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectAcknowledgedSelectValue = createSelector(
  [selectComposedReportState],
  ({ acknowledged }) => acknowledged
)
